module.exports = __webpack_public_path__ + "static/media/courses-hero.2bff941f.jpg";